import { Message, MessageStore } from "./types";

export const quotedMsgManager = ({
  set,
}: {
  set: (
    partial:
      | MessageStore
      | Partial<MessageStore>
      | ((state: MessageStore) => MessageStore | Partial<MessageStore>),
    replace?: false | undefined,
  ) => void;
  get: () => MessageStore;
}) => ({
  quotedMsg: undefined,
  setQuotedMsg: (quotedMsg?: Message) => {
    set({ quotedMsg });
  },
});
